import React from 'react';
import {
  ContentWrapper,
  Header,
  PopupContent,
  PopupImage,
  PopupTextBlock,
  ConfirmButton,
  DismissButton,
} from '../Popups.styles';
import { createPopup, closePopup } from '../../../services/popupService';
import { oneBtnPopupCreator, ESCALATE_POPUP_CONFIG } from '../ConfirmPopup/helper';
import { connect } from 'react-redux';
import {
  getEscalationMessage,
  getOutboundEscalationObject,
  extractSelectedTicketFromState,
  getBusinessBlacklistWordsInfoOfSelectedTicket,
  getBusinessBlacklistRegexesInfoOfSelectedTicket,
} from '../../../extractFromState';
import { setEscalationMessage, setOutboundEscalationObject } from '../../../actions/index';
import { isLiveChat } from 'util/chat';
import { getMatchingBlacklistedPhrases } from '../../../util/util';
import {
  ReasonDropdownSelect,
  ValidationErrorMessage,
  EscalateMessageTextArea,
  StyledSubheading,
} from './EscalatePopup.styles';
import { handleError } from 'services/ErrorService/ErrorService';
import GrammarlyEditorWrapper from '../../../wrappers/GrammarlyEditorWrapper';
import GrammarlyButtonWrapper from '../../../wrappers/GrammarlyButtonWrapper';

const GENERAL_ESCALATION_MESSAGE_FOR_EXPERTS = "If you can't resolve the ticket on your own, escalate to a specialist";
const GENERAL_ESCALATION_MESSAGE_FOR_SPECIALISTS = "If you can't resolve the ticket on your own, escalate to a partner";
const OTHER_REASON = 'Other';
const SELECT_A_REASON = 'Select a reason';

// the other escalate component harded coded it, following the style...
export const reasonOptions = [
  'Account Issue',
  'Address Change',
  'Adv. Troubleshooting',
  'Adv. Product Info',
  'Cancel Order',
  'Checkout/Payment Issue',
  'Defective/Quality Issue',
  'Delivered, Not Received',
  'Delivery Issue',
  'Discount Code Issue',
  'Edit Email',
  'Exchange Order',
  'Fulfillment Delay',
  'Incorrect or Missing Item(s)',
  'Internal Email',
  'Lost in Shipping',
  'Modify Order',
  'Negative Feedback',
  'No Order Information',
  'Price Match',
  'Refund Issue',
  'Refund Status',
  'Replacement Order Status',
  'Retroactive Discount',
  'Return Label Issue',
  'Return Order',
  'Return/Exchange Status',
  'Spam',
  'Website Issue',
  OTHER_REASON,
];

export default class EscalatePopupComponent extends React.Component {
  state = {
    reasonSelection: '',
    sendButtonDisabled: false,
  };

  // disable send button if default message has brackets
  componentDidMount() {
    if (this.props.outboundEscalationObject) {
      this.checkMessageBeforeSending(this.props.outboundEscalationObject.outboundEscalationMessage);
    }
  }

  getValidationError() {
    if (!this.props.escalationReason) {
      if (this.state.reasonSelection === SELECT_A_REASON || !this.state.reasonSelection) {
        return 'Please provide a reason for escalation.';
      }
      if (this.state.reasonSelection === OTHER_REASON && !this.props.escalationMessage.trim()) {
        return 'Please specify the reason here.';
      }
    }

    return null;
  }

  checkMessageBeforeSending(message) {
    try {
      const blacklistWords = this.props.blacklistWords;
      const blacklistRegexes = this.props.blacklistRegexes;
      const match = getMatchingBlacklistedPhrases(message, blacklistWords, blacklistRegexes);
      this.setState({ sendButtonDisabled: !!match });
    } catch (error) {
      handleError({ error });
      this.setState({ sendButtonDisabled: false });
    }
  }

  render() {
    return (
      <div>
        <ContentWrapper>
          <PopupContent width={'248px'}>
            <Header>Are you sure you want to escalate?</Header>
            <PopupTextBlock>
              {this.props.isAdmin || this.props.escalateToBusinessAsExpert
                ? GENERAL_ESCALATION_MESSAGE_FOR_SPECIALISTS
                : GENERAL_ESCALATION_MESSAGE_FOR_EXPERTS}
            </PopupTextBlock>
            {this.state.hasSubmitted && this.getValidationError() && (
              <ValidationErrorMessage error>
                <PopupImage src="/images/error-esclamation.svg" alt="error-icon" />
                {this.getValidationError()}
              </ValidationErrorMessage>
            )}
            {!this.props.escalationReason && (
              <>
                {(this.props.isAdmin || this.props.escalateToBusinessAsExpert) && (
                  <ReasonDropdownSelect
                    value={this.state.reasonSelection}
                    onChange={({ target: { value } }) => this.setState({ reasonSelection: value })}
                  >
                    <option>{SELECT_A_REASON}</option>
                    {reasonOptions.map((reason) => (
                      <option key={reason}>{reason}</option>
                    ))}
                  </ReasonDropdownSelect>
                )}
                <EscalateMessageTextArea
                  id="escalationReason"
                  autoFocus
                  type="text"
                  placeholder={
                    this.state.reasonSelection === OTHER_REASON ? 'Please specify the reason here...' : 'Anything else?'
                  }
                  value={this.props.escalationMessage}
                  onChange={({ target: { value } }) => {
                    this.props.setEscalationMessage(value);
                    this.setState({ hasSubmitted: false });
                  }}
                />
                {this.props.isSelectedTicketLiveChat && (
                  <>
                    <StyledSubheading>Send message to the customer</StyledSubheading>
                    <GrammarlyEditorWrapper>
                      <EscalateMessageTextArea
                        type="text"
                        placeholder="Please explain the escalation reason to the customer."
                        value={
                          this.props.outboundEscalationObject &&
                          this.props.outboundEscalationObject.outboundEscalationMessage
                        }
                        onChange={({ target: { value } }) => {
                          this.checkMessageBeforeSending(value);
                          this.props.setOutboundEscalationObject({
                            ...this.props.outboundEscalationObject,
                            outboundEscalationMessage: value,
                          });
                          this.setState({ hasSubmitted: false });
                        }}
                      />
                      <GrammarlyButtonWrapper />
                    </GrammarlyEditorWrapper>
                  </>
                )}
              </>
            )}
          </PopupContent>
        </ContentWrapper>
        <DismissButton
          onClick={() => {
            closePopup();
          }}
        >
          Dismiss
        </DismissButton>
        <ConfirmButton
          disabled={this.state.sendButtonDisabled}
          onClick={() => {
            this.setState({ hasSubmitted: true });
            if (!this.getValidationError()) {
              closePopup();
              this.props
                .onEscalate({
                  reasonSelection: this.props.escalationReason || this.state.reasonSelection,
                  escalateMessage: this.props.escalationMessage,
                })
                .then(() => oneBtnPopupCreator(ESCALATE_POPUP_CONFIG.escalateConfirmConfig))
                .catch((error) => handleError({ error }));
            }
          }}
        >
          Escalate Now
        </ConfirmButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  escalationMessage: getEscalationMessage(state),
  outboundEscalationObject: getOutboundEscalationObject(state),
  isSelectedTicketLiveChat:
    !!extractSelectedTicketFromState(state) && !!isLiveChat(extractSelectedTicketFromState(state).communicationType),
  blacklistWords: getBusinessBlacklistWordsInfoOfSelectedTicket(state),
  blacklistRegexes: getBusinessBlacklistRegexesInfoOfSelectedTicket(state),
});

const mapDispatchToProps = (dispatch) => ({
  setEscalationMessage(escalationMessage) {
    dispatch(setEscalationMessage(escalationMessage));
  },
  setOutboundEscalationObject(message) {
    dispatch(setOutboundEscalationObject(message));
  },
});

const EscalateComponentContainer = connect(mapStateToProps, mapDispatchToProps)(EscalatePopupComponent);

export const openEscalationPopup = (isAdmin, escalationReason, onEscalate, escalateToBusinessAsExpert = false) =>
  createPopup({
    type: 'EscalatePopupComponent',
    title: null,
    content: (
      <EscalateComponentContainer
        onEscalate={onEscalate}
        isAdmin={isAdmin}
        escalateToBusinessAsExpert={escalateToBusinessAsExpert}
        escalationReason={escalationReason}
      />
    ),
    noOverlay: false,
    closeOnOutsideClick: false,
  });
